import React from "react";
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { DrawerContextProvider } from "./src/contexts/DrawerContext";
import { ModalTicketContextProvider } from "./src/contexts/ModalTicketContext";
import "./src/styles/global.scss";

export const wrapRootElement = ({ element }) => (
  <DrawerContextProvider>
    <ModalTicketContextProvider>
      {/* <Header /> */}
      {element}
      {/* <Footer /> */}
    </ModalTicketContextProvider>
  </DrawerContextProvider>
);
